import * as React from 'react';
import { config } from '@fortawesome/fontawesome-svg-core';

import '@fortawesome/fontawesome-svg-core/styles.css';
config.autoAddCss = false;

import {
  faChevronRight as fasChevronRight,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import FeatureType from '../features/FeatureType';

export default function ModalPropertyFeatures ( props ) {

  return (

    <div className="modal-body">
      <div className="row">
        {
          props.feature_groups.map( ( parent_group ) => {
            return (
              <div key={parent_group.group_id.toString()} className="col-12">
                {
                  parent_group.group.map( ( child_group ) => {
                    return (
                      child_group.features.length > 0 &&
                        <div key={child_group.group_id.toString()}>
                          <div className="block-title p-b-15 text-black">{child_group.group_title}
                            <FontAwesomeIcon icon={fasChevronRight}
                              className="text-black m-l-10 fw-normal fs-11"
                              style={{ verticalAlign: 'initial' }}/>
                          </div>
                          {child_group.features.length > 0 &&
                            child_group.features.map( ( feature ) => {
                              return (
                                <div key={feature.feature_id.toString()}>
                                  <FeatureType feature={feature}/>
                                </div>
                              )
                            })
                          }
                        </div>
                    )
                  })
                }
              </div>
            )
          })
        }
      </div>
    </div>
  )
}
